<template>
    <div v-wechat-title="title">
        <div style="margin: 5px">

             <!-- 可选设备（蓝色） -->
  <div class="group-title blue align-left">可选设备</div>
  <el-row :gutter="10" class="nurse-group">
    <el-col
      v-for="n in mobileDevice"
      :key="n.id"
      :span="4"
    >
      <div
        class="nurse-tag blue"
         :class="{selected: localSelectedDevice.includes(n.id)}"
        @click="toggleNurse(n.id)"
      >
        {{ n.name }}
      </div>
    </el-col>
  </el-row>
  <!-- 未排（黄色） -->
  <div class="group-title yellow align-left">不可选设备</div>
  <el-row :gutter="10" class="nurse-group">
    <el-col
      v-for="n in unmobileDevice"
      :key="n.id"
      :span="4"
    >
      <div
        class="nurse-tag yellow"
      >
        {{ n.name }}
      </div>
    </el-col>
  </el-row>
        </div>
        <CloseButton type="confirm" @confirm="ConfirmDevice" :data="data" :msg="msg"> </CloseButton>
    </div>
</template>
<script>
export default {
    name: `MobileDeviceBind`,
    props: {

    },
    data() {
        return {
            title: `移动设备绑定`,
            token: this.$route.query.token,
            recordType: this.$route.query.recordType,
            id: this.$route.query.surgery_id,
            AfterOtherEventClickProc: this.$root.AfterOtherEventClickProc,
            data: {},
            msg: `closeWindow`,
            mobileDevice: [],
            unmobileDevice: [],
            localSelectedDevice: [] // 弹层多选确定
        }
    },
    created() {
        sessionStorage.setItem(`token`, this.token)
        this.init()
    },
    computed: {
    },
    methods: {
        init() {
            let that = this
            // 获取所有的移动设备
            let req2 = this.myaxios.get(`/api/AcisSystem/Device/GetMobile`)
            req2.then(devices => {
                that.mobileDevice = devices.filter(s => s.biz_surgery_info_id == null || s.biz_surgery_info_id == that.id)
                that.unmobileDevice = devices.filter(s => s.biz_surgery_info_id != null && s.biz_surgery_info_id != that.id)
                that.localSelectedDevice = devices.filter(s => s.biz_surgery_info_id == that.id).map(i => i && i.id)
            })
        },
        /* 弹层内切换选中 */
        toggleNurse(id) {
            const idx = this.localSelectedDevice.indexOf(id)
            idx === -1
                ? this.localSelectedDevice.push(id)
                : this.localSelectedDevice.splice(idx, 1)
        },
        ConfirmDevice() {
            let that = this
            let surid = that.id
            this.$confirm(`提示`, {
                title: `提示`,
                message: this.$createElement(`div`, [this.$createElement(`p`, `是否确定绑定当前患者移动设备？`)]),
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    this.myaxios.post(
                        `/api/AcisSystem/Device/PostMobile?biz_surgery_info_id=${surid}`, that.localSelectedDevice
                    ).then(data => {
                        var cefJson = {
                            action: `openAnes`,
                            id: surid
                        }
                        winformMsg.acceptMessage(cefJson)
                        that.ControlDevice = false
                    }).catch(e => console.log(e))
                })
                .catch(e => {
                    console.log(e)
                })
        },
        ClearDevice() {
            let that = this
            let surid = this.chooseRow.surgeryInfoId || this.chooseRow.id
            this.$confirm(`提示`, {
                title: `提示`,
                message: this.$createElement(`div`, [this.$createElement(`p`, `是否确定清除当前患者移动设备绑定？`)]),
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    this.myaxios.post(
                        `/api/AcisSystem/Device/ClearMobile?biz_surgery_info_id=${surid}`
                    ).then(data => {
                        that.ControlDevice = false
                    }).catch(e => console.log(e))
                })
                .catch(e => {
                    console.log(e)
                })
        },
        sendMessage() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: this.data,
                    action: this.msg
                }
                winformMsg.acceptMessage(cefJson)
            }
        }
    },
    watch: {
    }
}
</script>
<style scoped>
.note {
    display: inline-block;
    position: absolute;
    left: 5px;
}
</style>
<style lang="less">
.group-title {
  font-weight: bold;
  margin: 12px 0 6px;
}
.blue { color: #409EFF; }
.yellow { color: #E6A23C; }

.nurse-group {
  margin-bottom: 12px;
}
.nurse-tag {
  padding: 6px 10px;
  margin-bottom: 6px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  border: 1px solid #dcdcdc;
  transition: all .2s;
}
.nurse-tag.selected {
  background: var(--primary-color, #009688);
  color: #fff;
  border-color: var(--primary-color, #009688);
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/MobileDeviceBind.vue